
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Aarti "Yei Ho Vitthal" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Yei Ho Vitthal" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Yei Ho Vitthal Aarti, Vitthal Aarti, Vitthal Bhakti, Vitthal worship, Vitthal Marathi Aarti, Panduranga Aarti, Pandurang Bhajan, Vithoba Aarti'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Yei Ho Vitthal Aarti, Vitthal Aarti, Vitthal Bhakti, Vitthal worship, Vitthal Marathi Aarti, Panduranga Aarti, Pandurang Bhajan, Vithoba Aarti, Sant Tukaram Vitthal Aarti, devotional aarti, Aarti of Lord Vitthal, Vitthal Aarti lyrics in Marathi, Vitthal temple Aarti, Sant Dnyaneshwar Aarti, Lord Vithoba, Vitthal Aarti lyrics in english, yei ho vitthale lyrics in english, yei ho vitthale lyrics in marathi, yei ho vitthale aarti'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/pandhuranga.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/pandhuranga.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Yei Ho Vitthal | Pandurangachi Aarti - येई हो विठ्ठले (पांडुरंगाची आरती)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/pandhuranga"
        },
        "headline": "Yei Ho Vitthal - येई हो विठ्ठले (पांडुरंगाची आरती)",
        "name" : "Yei Ho Vitthal - Pandurangachi Aarti",
        "description": "Explore the full lyrics of Aarti 'Yei Ho Vitthal' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/pandhuranga.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  